import { ANONYMIZATION_DICTIONARY } from './anonymization-dictionary';

export interface AnonymizationConfig {
  /**
   * Email dell'utente per cui applicare l'anonimizzazione.
   */
  targetUserEmail: string;

  /**
   * Divisore fisso applicato ai valori economici in € intercettati dal backend.
   */
  fixedDivisor: number;

  /**
   * Range min-max per il divisore casuale dei numeri intercettati dal backend (se non fisso).
   */
  divisorRange: {
    min: number;
    max: number;
  };

  /**
   * Modalità del divisore:
   * - 'fixed': utilizza sempre fixedDivisor (es. 3.14)
   * - 'float': genera numeri decimali casuali nel range (es. 2.35)
   * - 'integer': genera numeri interi casuali nel range (es. 2, 3, 4, 5)
   */
  divisorMode: 'fixed' | 'float' | 'integer';

  /**
   * Se true, genera un divisore diverso per ogni singolo numero trovato.
   * Se false (consigliato), genera un unico divisore coerente per la risposta,
   * preservando l'ordinamento e le proporzioni delle tabelle e dei grafici.
   */
  divisorPerNumber: boolean;

  /**
   * Stringa sostitutiva di default per le parole anonimizzate (senza asterischi).
   */
  defaultWordReplacement: string;

  /**
   * Mappa di parole/frasi personalizzate con le rispettive sostituzioni (case-insensitive).
   * Contiene tutte le entità estratte da BigQuery con corrispettivi realistici immaginari.
   */
  wordsToReplace: Record<string, string>;

  /**
   * Elenco di parole da anonimizzare usando defaultWordReplacement.
   */
  wordList: string[];
}

export const ANONYMIZATION_CONFIG: AnonymizationConfig = {
  targetUserEmail: 'mario.rossi@telecomitalia.it',
  fixedDivisor: 3.14,
  divisorRange: {
    min: 1,
    max: 5,
  },
  divisorMode: 'fixed',
  divisorPerNumber: false,
  defaultWordReplacement: 'Hyperion',
  wordsToReplace: {
    tiaky: 'Hyperion',
    TIAKY: 'HYPERION',
    Tiaky: 'Hyperion',
    'tiaki-arc': 'Hyperion-Arc',
    'TIAKI-ARC': 'HYPERION-ARC',
    'Tiaki-Arc': 'Hyperion-Arc',
    'tiaky-arc': 'Hyperion-Arc',
    'TIAKY-ARC': 'HYPERION-ARC',
    'Tiaky-Arc': 'Hyperion-Arc',
    ...ANONYMIZATION_DICTIONARY,
  },
  wordList: [
    'tiaky',
    'tiaki-arc',
    'tiaky-arc',
  ],
};
